import {connect} from 'react-redux'
import Uebersicht from './index'

const mapStateToProps = state => ({
  userId: state.authentication.id,
})

export default connect(mapStateToProps)(Uebersicht)
